module.exports = __webpack_public_path__ + "img/united-rental-logo.4bfa7221.jpg";